import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import { logoutUserSuccess } from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

//Calendar
import CalendarReducer from "./calendar/reducer";
//Chat
import chatReducer from "./chat/reducer";
//Ecommerce
import EcommerceReducer from "./ecommerce/reducer";

//Project
import ProjectsReducer from "./projects/reducer";

// Tasks
import TasksReducer from "./tasks/reducer";

//Crypto
import CryptoReducer from "./crypto/reducer";

//Crm
import CrmReducer from "./crm/reducer";

//Invoice
import InvoiceReducer from "./invoice/reducer";

//Mailbox
import MailboxReducer from "./mailbox/reducer";

// Dashboard Analytics
import DashboardAnalyticsReducer from "./dashboardAnalytics/reducer";

// Dashboard CRM
import DashboardCRMReducer from "./dashboardCRM/reducer";

// Dashboard Ecommerce
import DashboardEcommerceReducer from "./dashboardEcommerce/reducer";

// Dashboard Cryto
import DashboardCryptoReducer from "./dashboardCrypto/reducer";

// Dashboard Cryto
import DashboardProjectReducer from "./dashboardProject/reducer";

// Dashboard NFT
import DashboardNFTReducer from "./dashboardNFT/reducer";

// Dashboard JOb
import DashboardJobReducer from "./dashboardJob/reducer";

// Pages > Team
import TeamDataReducer from "./team/reducer";

// File Manager
import FileManagerReducer from "./fileManager/reducer";

// To do
import TodosReducer from "./todos/reducer";

// Job
import JobReducer from "./jobs/reducer";

// API Key
import APIKeyReducer from "./apiKey/reducer";

// Audit Logs - ADDED
import AuditLogsReducer from "./auditLogs/reducer";

// User Management - ADDED
import UserManagementReducer from "./userManagement/reducer";

// Role Management - ADDED
import RoleManagementReducer from "./roleManagement/reducer";

// System Configuration - ADDED
import SystemConfigurationReducer from "./systemConfiguration/reducer";

// Branding Configuration - ADDED
import BrandingConfigurationReducer from "./brandingConfiguration/reducer";

// Brand Management - ADDED
import BrandManagementReducer from "./brandManagement/reducer";

// Agent Management - ADDED
import AgentManagementReducer from "./agentManagement/reducer";

// Tenant Management - ADDED
import TenantManagementReducer from "./tenantManagement/reducer";

// Ticket Design Template - ADDED
import TicketDesignTemplateReducer from "./ticketDesignTemplate/reducer";

// Ticket Type Management - ADDED
import TicketTypeReducer from "./ticketType/reducer";

// Sinh Bộ Số & QR - ADDED
import SinhBoSoQrReducer from "./sinhBoSoQr/reducer";

// Prize Structure Management (Cơ cấu Giải thưởng) - ADDED
import PrizeStructureReducer from "./prizeStructure/reducer";

// Draw Result Management (Kết quả Quay số) - ADDED
import DrawResultReducer from "./drawResult/reducer";

// Notification Management - ADDED
import NotificationsReducer from "./notifications/reducer";

// User Profile - ADDED
import UserProfileReducer from "./userProfile/reducer";

// Module Management (quản lý module cha/con) - ADDED
import ModuleManagementReducer from "./moduleManagement/reducer";

// Prize Claim Dossier (Thẩm định Hồ sơ Trả thưởng) - ADDED
import ClaimDossierReducer from "./claimDossier/reducer";

const appReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Calendar: CalendarReducer,
    Chat: chatReducer,
    Projects: ProjectsReducer,
    Ecommerce: EcommerceReducer,
    Tasks: TasksReducer,
    Crypto: CryptoReducer,
    Crm: CrmReducer,
    Invoice: InvoiceReducer,
    Mailbox: MailboxReducer,
    DashboardAnalytics: DashboardAnalyticsReducer,
    DashboardCRM: DashboardCRMReducer,
    DashboardEcommerce: DashboardEcommerceReducer,
    DashboardCrypto: DashboardCryptoReducer,
    DashboardProject: DashboardProjectReducer,
    DashboardNFT: DashboardNFTReducer,
    DashBoardJob: DashboardJobReducer,
    Team: TeamDataReducer,
    FileManager: FileManagerReducer,
    Todos: TodosReducer,
    Jobs: JobReducer,
    APIKey: APIKeyReducer,
    AuditLogs: AuditLogsReducer,
    UserManagement: UserManagementReducer,
    RoleManagement: RoleManagementReducer,
    SystemConfiguration: SystemConfigurationReducer,
    BrandingConfiguration: BrandingConfigurationReducer,
    BrandManagement: BrandManagementReducer,
    AgentManagement: AgentManagementReducer,
    TenantManagement: TenantManagementReducer,
    TicketDesignTemplate: TicketDesignTemplateReducer,
    TicketType: TicketTypeReducer,
    SinhBoSoQr: SinhBoSoQrReducer,
    PrizeStructure: PrizeStructureReducer,
    DrawResult: DrawResultReducer,
    Notifications: NotificationsReducer,
    UserProfile: UserProfileReducer,
    ModuleManagement: ModuleManagementReducer,
    ClaimDossier: ClaimDossierReducer

});

export type RootState = ReturnType<typeof appReducer>;

// Reset toàn bộ Redux store về initial state khi logout — nếu không, những slice cache dữ liệu
// theo user (VD UserProfile.profile) sẽ vẫn giữ nguyên dữ liệu tài khoản cũ khi đăng nhập lại
// bằng tài khoản khác trong cùng phiên SPA (không có full page reload), phải bấm F5 mới thấy đúng.
const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
    if (action.type === logoutUserSuccess.type) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
